import { useContext } from "react";
import { createPortal } from "react-dom";
import { LinearProgress } from "@mui/material";

import { LoadingBarSlotContext } from "../Contexts/LoadingBarSlotContext";

const LoadingBar = () => {
  const slot = useContext(LoadingBarSlotContext);

  return slot && createPortal(<LinearProgress />, slot);
};

export default LoadingBar;
